/**
 * A simple, select field that allows the current admin user to select a state.
 *
 * Currently used by the Checkout and UpdateCreditCard modals to gather account
 * invoice address information.
 */

import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

import { getStates } from "../../../iso";
import { CountryCodeRequiringState, State } from "../../../types";

interface StateSelectFieldProps {
  countryCode: CountryCodeRequiringState;
  label: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  required?: boolean;
}

function StateSelectField(props: StateSelectFieldProps) {
  return (
    <TextField
      label={props.label}
      name={props.name}
      onChange={props.onChange}
      required={props.required}
      value={props.value}
      select
    >
      {getStates(props.countryCode).map((state: State) => {
        return (
          <MenuItem key={state.code} value={state.code}>
            {state.name}
          </MenuItem>
        );
      })}
    </TextField>
  );
}

export default StateSelectField;
